import Service from "./config/ConfigRepositoryAuth";

export default {
  async corteCaja(date) {
    return await Service.get(`sales/${date}`);
  },
  async snapshot(date) {
    return await Service.get(`sales/${date}/snapshot`);
  },
};